import { Fragment, useEffect, useState } from "react";
import { Env } from "../../enviroment/environment";
import useWindowDimensions from "../../helpers/WindowWidth";
import {useSelector } from "react-redux";
import cardHolderService from "../../services/cardholder.service";
import RefreshToken from "../../helpers/RefreshToken";
import BoLoader from "../../helpers/BoLoader";

const BADashBoard = (props) => {
  const { height, width } = useWindowDimensions();
  const { user: currentUser } = useSelector(state => state.auth);
  var setpermission = localStorage.getItem("activeInactiveSendmoney");
  const [cardHolderDetail, setCardHolderDetail] = useState();
  const [kycstatus, setKycstatus] = useState("");
  const [boloader, setBoLoader] = useState(false);


  useEffect(() => {
    callHolderServiceCall();
  }, [props?.location?.state]);
  const callHolderServiceCall = async () => {
    await cardHolderService
      .getcorporateaccountdetails(currentUser?.user?.UserId)
      .then(res => {
        if (res && res.data && res.data.success) {
          if (res && res.data && res.data.payload) {
            setCardHolderDetail(res.data.payload?.item1);

          } 
        }
      })
      .catch(err => {
        (async () => {
          let resp = await RefreshToken(
            err && err.response && err.response.status
          );
          if (resp) {
            window.location.reload();
          } 
        })();
      });
  };
useEffect(()=>{
  setBoLoader(true);
    cardHolderService.checkstatus(currentUser?.user?.UserId).then((resp)=>{
      setBoLoader(false);
    let msg = resp?.data?.payload?.item1;
    setKycstatus(msg);
  
}).catch((error)=>{
  setBoLoader(false);
  try {
    let msgBody = error?.message;
    setKycstatus(msgBody);
  } catch (e) {
    console.error("Error parsing error message:", e);
  }
});
},[])
  return (
    <Fragment>
       <BoLoader loading={boloader}/>
      {
        kycstatus==="APPROVED" ?(
          <div className="col-xl-6 col-lg-8 col-md-12 bo-main-content">
           
          <h3>
            Your Bank Account<span className="bo-badge bo-badge-large"></span>
          </h3>
          <div className="row mt-20">
          <div className="row-card-holder-details mb-40">
              <div className="row flex-column-reverse flex-sm-row">
                <div className="col-md-12 col-sm-8">
                  <ul className="ul-card-details">
                    <li>
                    <div className="mb-20">
                    <p>Registered Name</p>
                      <h5> {cardHolderDetail?.registeredName}</h5>
                      </div>
                      <div className="mb-20">
                        <p>Email</p>
                        <h5 className="text-break"> {cardHolderDetail?.email}</h5>
                      </div>
                      <div className="mb-20">
                        <p>Currency</p>
                        <h5>
                          $
                        </h5>
                      </div>
                      <div className="mb-20">
                        <p>Date of Birth</p>
                        <h5>
                        <h5> {cardHolderDetail?.firstName+ ` `+cardHolderDetail?.lastName}</h5>
                        </h5>
                      </div>
                      <div className="mb-20">
                        <p>City</p>
                        <h5> {cardHolderDetail?.city}</h5>
                      </div>
                    </li>
                    <li>
                      
                     
                      <div className="mb-20">
                        <p>Country</p>
                        <h5> {cardHolderDetail?.country}</h5>
                      </div>
                      <div className="mb-20">
                        <p>Zip Code</p>
                        <h5> {cardHolderDetail?.zipCode}</h5>
                      </div>
                      <div className="mb-20">
                      <p>Account Number ACH</p>
                      <h5> {cardHolderDetail?.accountNumberAch ? cardHolderDetail?.accountNumberAch:"-"}</h5>
                    </div>
                    <div className="mb-20">
                      <p>Routing Number ACH</p>
                      <h5> {cardHolderDetail?.routingNumberAch ? cardHolderDetail?.routingNumberAch:"-"}</h5>
                    </div>
                    <div className="mb-20">
                      <p>Account Number FED</p>
                      <h5> {cardHolderDetail?.accountNumberFed ? cardHolderDetail?.accountNumberFed:"-"}</h5>
                    </div>
                    </li>
                    <li>
                    
                    <div className="mb-20">
                      <p>Routing Number FED</p>
                      <h5> {cardHolderDetail?.routingNumberFed?cardHolderDetail?.routingNumberFed:"-"}</h5>
                    </div>
                    <div className="mb-20">
                      <p>Account Number Swift</p>
                      <h5> {cardHolderDetail?.accountNumberSwift?cardHolderDetail?.accountNumberSwift:"-"}</h5>
                    </div>
                    <div className="mb-20">
                      <p>Swift Bic</p>
                      <h5> {cardHolderDetail?.swiftBic ? cardHolderDetail?.swiftBic:"-"}</h5>
                    </div>
                   <div className="mb-20">

                        <p>Token Id</p>
                        <h5> {cardHolderDetail?.tokenId}</h5>
                      </div>
                      <div className="mb-20">
                        <p>KYC Status</p>
                        <h5> {kycstatus}</h5>
                      </div>

                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
  
          {/* for mobile */}
          <div className="row">       
          </div>      
        </div>
        ): !boloader ?(<>
        <div className="col-xl-6 col-lg-8 col-md-12 bo-main-content">
        <div className="bo-on-screens position-relative onbo-content-center minh-row-mbl">
        <div className="col-md-8 col-lg-6 col-xl-5">
                <div className="icon-alert">
                  <span className="icon-successful">
                    <span className="path1"></span>
                    <span className="path2"></span>
                  </span>
                </div>
                <h3 className="mb-4">Great, All Done!</h3>
                <h6>We are reviewing your documents </h6>
                <div className="form-group submit-field mt-40">
                  <a to="/login" className="btn btn-large w-100" onClick={() => { sessionStorage.removeItem("user"); window.location.reload(); }}>
                    Logout
                  </a>
                </div>
              </div>
                            </div>
                            </div>
                           
        </>):(<></>)
      }
     
   

      
    </Fragment>
  );
};

export default BADashBoard;
